export function About() {
  const values = [
    {
      title: 'Company Mission',
      description: 'At BRZOGLAS, we believe privacy is a fundamental right. Our mission is to provide accessible, reliable VPN solutions that empower users to take control of their digital security and browse the internet without fear of surveillance or data theft.'
    },
    {
      title: 'Technology Approach',
      description: 'We leverage cutting-edge encryption protocols and advanced security technologies to deliver a VPN service that never compromises on speed or reliability. Our infrastructure is built with performance and privacy as top priorities.'
    },
    {
      title: 'Privacy Commitment',
      description: 'We maintain a strict zero-log policy and operate under robust privacy laws. Your data belongs to you alone. We never track, store, or share your browsing activity, ensuring complete anonymity and peace of mind.'
    },
    {
      title: 'Croatian Innovation',
      description: 'Proudly based in Kastel Novi, Croatia, we combine European privacy standards with innovative technology. Our local expertise and global perspective enable us to deliver world-class security solutions.'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-emerald-100 rounded-full mb-4">
            <span className="text-sm text-emerald-800 font-semibold">About BRZOGLAS</span>
          </div>
          <h3 className="text-5xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Protecting Digital Privacy Since Day One
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mt-12">
          {values.map((value, index) => (
            <div key={index} className="relative">
              {index < 3 && (
                <div className="hidden md:block absolute top-0 right-0 w-px h-full bg-gray-200"></div>
              )}
              <h4 className="text-xl font-bold text-indigo-600 mb-4">{value.title}</h4>
              <p className="text-gray-600 leading-relaxed text-sm">{value.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-gradient-to-br from-gray-50 to-white rounded-3xl p-12 border border-gray-200">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h4 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Why Choose Our VPN?
              </h4>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-check-line text-teal-600 text-lg"></i>
                  </div>
                  <div>
                    <strong className="text-gray-900 font-semibold">No Data Limits</strong>
                    <p className="text-gray-600 text-sm mt-1">Unlimited bandwidth for streaming, browsing, and downloading</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-check-line text-teal-600 text-lg"></i>
                  </div>
                  <div>
                    <strong className="text-gray-900 font-semibold">Lightning Fast Speeds</strong>
                    <p className="text-gray-600 text-sm mt-1">Optimized servers ensure minimal speed reduction</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-check-line text-teal-600 text-lg"></i>
                  </div>
                  <div>
                    <strong className="text-gray-900 font-semibold">Easy to Use</strong>
                    <p className="text-gray-600 text-sm mt-1">One-click connection with intuitive interface</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-check-line text-teal-600 text-lg"></i>
                  </div>
                  <div>
                    <strong className="text-gray-900 font-semibold">Trusted Security</strong>
                    <p className="text-gray-600 text-sm mt-1">Industry-leading protocols and regular security audits</p>
                  </div>
                </div>
              </div>
            </div>
            <div 
              className="rounded-2xl h-96 bg-cover bg-center"
              style={{
                backgroundImage: 'url(https://public.readdy.ai/ai/img_res/f0843890604e530628f4b1d5732ec9dc.jpg)'
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
